import React from 'react';
import DefinitionTooltip from 'src/components/Tooltip/DefinitionTooltip/DefinitionTooltip';
import { WithChildren } from 'src/utils/UtilityTypes';

const TriggerConditionTooltip = ({ children }: WithChildren) => {
	return (
		<DefinitionTooltip definitionId="ordersReferencePrice">
			{children}
		</DefinitionTooltip>
	);
};

export default TriggerConditionTooltip;
